// Geteilte Seiten (/next/spot, /next/trip): der Inhalt kommt fertig vom Server. Hier nur Fotoansicht, Teilen und
// Merken — ohne Designsystem-JS (sonst käme der ganze ui-Chunk mit). Texte über window.tr aus /js/i18n.js.

const tr = (k, v) => (typeof window !== 'undefined' && window.tr ? window.tr(k, v) : k);

/** Nächster Index im Kreis (Fotoansicht). */
export function step(i, dir, n) { return n > 0 ? ((i + dir) % n + n) % n : 0; }

function toast(text) {
  let el = document.querySelector('.ss-toast');
  if (!el) { el = document.createElement('p'); el.className = 'ss-toast'; el.setAttribute('role', 'status'); document.body.append(el); }
  el.textContent = text;
  el.classList.add('is-on');
  clearTimeout(el._t); el._t = setTimeout(() => el.classList.remove('is-on'), 2600);
}

function initLightbox() {
  const links = [...document.querySelectorAll('[data-ss-photo]')];
  const dlg = document.querySelector('.ss-lightbox');
  if (!links.length || !dlg || typeof dlg.showModal !== 'function') return; // ohne <dialog>: Link öffnet das Bild
  const img = dlg.querySelector('img'), count = dlg.querySelector('.ss-lb-count');
  let i = 0, x0 = null;
  const show = (k) => { i = k; img.src = links[i].getAttribute('href'); count.textContent = (i + 1) + ' / ' + links.length; };
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-ss-photo]');
    if (a) { e.preventDefault(); show(Number(a.dataset.ssPhoto)); dlg.showModal(); return; }
    const b = e.target.closest('[data-ss-lb]');
    if (b) { const a2 = b.dataset.ssLb; if (a2 === 'close') dlg.close(); else show(step(i, a2 === 'next' ? 1 : -1, links.length)); return; }
    if (e.target === dlg) dlg.close(); // Klick auf den Hintergrund
  });
  dlg.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowRight') show(step(i, 1, links.length));
    if (e.key === 'ArrowLeft') show(step(i, -1, links.length));
  });
  dlg.addEventListener('pointerdown', (e) => { x0 = e.clientX; });
  dlg.addEventListener('pointerup', (e) => {
    if (x0 == null) return; const dx = e.clientX - x0; x0 = null;
    if (Math.abs(dx) > 50) show(step(i, dx < 0 ? 1 : -1, links.length));
  });
  // Nach dem Schließen setzt der Browser den Fokus selbst auf den öffnenden Link — erst danach auf das
  // zuletzt gezeigte Foto setzen und den Streifen waagerecht dorthin schieben (nie die Seite senkrecht).
  dlg.addEventListener('close', () => setTimeout(() => {
    const a = links[i]; if (!a) return;
    const strip = a.closest('.ss-strip'), li = a.closest('li');
    if (strip && li) strip.scrollLeft = li.offsetLeft - strip.offsetLeft - (parseFloat(getComputedStyle(strip).paddingLeft) || 0);
    a.focus({ preventScroll: true });
  }, 0));
}

function initShare() {
  document.addEventListener('click', async (e) => {
    if (!e.target.closest('[data-ss-share]')) return;
    const data = { title: document.title, url: location.origin + location.pathname.replace(/^\/next\//, '/') + location.search };
    // In der ViaCamp-App (Flutter-WebView) über die native Brücke — die Android-WebView kennt navigator.share nicht.
    const fb = window.flutter_inappwebview;
    if (fb && typeof fb.callHandler === 'function') { try { const r = await fb.callHandler('share', data); if (r && r.ok) return; } catch { /* Web-Weg */ } }
    if (navigator.share) { try { await navigator.share(data); return; } catch (err) { if (err && err.name === 'AbortError') return; } }
    try { await navigator.clipboard.writeText(data.url); toast(tr('pub.share_copied')); } catch { toast(data.url); }
  });
}

function initFav() {
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-ss-fav]');
    if (!b || b.disabled) return;
    const on = b.getAttribute('aria-pressed') !== 'true';
    const set = (v) => {
      b.setAttribute('aria-pressed', String(v)); b.classList.toggle('is-on', v);
      const label = tr(v ? 'spot_js.fav_remove' : 'spot_js.fav_add'); b.setAttribute('aria-label', label); b.title = label;
    };
    set(on); b.disabled = true;
    try {
      const r = await fetch('/api/favorites/' + encodeURIComponent(b.dataset.ssFav), { method: on ? 'POST' : 'DELETE', credentials: 'same-origin' });
      if (!r.ok) throw new Error(String(r.status));
    } catch { set(!on); toast(tr('pub.fav_error')); }
    b.disabled = false;
  });
}

if (typeof document !== 'undefined') { initLightbox(); initShare(); initFav(); }
